import formatLink from 'lemon-campaign-ui/lib/util/formatLink.js'

if (typeof window !== `undefined`) {
  window.delay = function delay(URL) {
    setTimeout(function() {
      window.location.href = formatLink(URL)
    }, 300)
  }
}

const linking = (component) => {
  if (!component.content.linking.isInternal) {
    return component.content.linking.url
  }

  return undefined
}

export default linking
